// @ts-ignore
import $ from 'jquery';

export default class UIFullModal {

    public nodeId          : string = "ui-full-modal"
    public containerNodeId : string = "ui-full-modal-container"

    constructor() {
    }

    destroy() {
        $("#"+this.nodeId).empty();
        $("#"+this.nodeId).remove();

        $("#ui-div-zero").removeClass('blur');
    }

    create(className=null, noOverlay = false) {

        let classValue = (className)?'class="'+className+'"':'';
        const overlay = noOverlay ? "" : "<div class='overlay'></div>";

        $("#ui-div-zero").addClass('blur');
        $("#ui-layout-container").append("<div id='"+this.nodeId+"' "+classValue+"> "+overlay+" <div id='"+this.containerNodeId+"'></div> </div>");
    }

}
